import { ComponentManager, DataTransferObject } from "radpresentation.htmlclient.defaultviewextensions";
import WFEOperationDTO from './WFEOperationDTO';

export default class WFEUserTaskContainerDTO extends DataTransferObject {

    public Operations: Array<WFEOperationDTO>;

    public UIConfigurations: Array<any>;

    public constructor() {
        super({xmlProperties: ['Operations', 'UIConfigurations'], xmlNamespace: 'WorkflowEngine'});

        this.Operations = this.defaultFromType('array');
        this.UIConfigurations = this.defaultFromType('array');
    }
}

ComponentManager.setModel('WFEUserTaskContainerDTO', WFEUserTaskContainerDTO, 'WorkflowEngineHTMLViewExtension');